import { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { PopUpTablet } from '@bwoty-web/styleguide';
import { FilterDestinations } from './FilterDestinations';
import { FilterPrice } from './FilterPrice';

import styles from './FilterBar.scss';
import { FilterTripType } from './FilterTripType';
import { FilterBarFooter } from './FilterBarFooter';

export const FilterBar = (props) => {
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 975);
  useEffect(() => {
    function handleResize() {
      setIsWideScreen(window.innerWidth > 975);
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const {
    header,
    isOpen,
    onClose,
    onFilter,
    destinations,
    selectedDestinations,
    destinationsHeader,
    priceHeader,
    priceLabel,
    priceRange,
    selectedPrice,
    tripTypeHeader,
    tripTypes,
    selectedTripTypes,
    resetFilterLabel,
    showFilteredLabel,
    onReset,
    onShowFiltered,
    totalCount,
  } = props;

  const handleIsOpen = () => {
    if (isWideScreen) {
      // if we are on a wide screen, we always want to show the filter bar
      return true;
    }

    return isOpen;
  };

  const hasFilters = Boolean(
    selectedDestinations.length || selectedTripTypes.length || selectedPrice !== null,
  );

  const footer = (
    <FilterBarFooter
      showReset={hasFilters}
      showFilteredLabel={showFilteredLabel}
      resetFilterLabel={resetFilterLabel}
      disableShowFiltered={totalCount === 0}
      onReset={onReset}
      onShowFiltered={onShowFiltered}
    />
  );

  return (
    <div className={styles.root}>
      <div className={classNames(styles.backdrop, { [styles.backDropVisible]: isOpen })}>
        <PopUpTablet
          className={styles.popup}
          header={<h2>{header}</h2>}
          close={onClose}
          closed={!handleIsOpen()}
          footer={footer}
        >
          <div className={classNames(styles.content, { [styles.hasFooter]: hasFilters })}>
            <FilterTripType
              header={tripTypeHeader}
              tripTypes={tripTypes}
              selected={selectedTripTypes}
              onFilter={onFilter}
            />
            <FilterPrice
              header={priceHeader}
              hidden={!isOpen}
              valueLabel={priceLabel}
              value={selectedPrice}
              max={priceRange.max}
              min={priceRange.min}
              onFilter={onFilter}
            />
            <FilterDestinations
              destinations={destinations}
              selected={selectedDestinations}
              header={destinationsHeader}
              onFilter={onFilter}
            />
          </div>
        </PopUpTablet>
      </div>
    </div>
  );
};

FilterBar.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onFilter: PropTypes.func,
  header: PropTypes.node,
  priceRange: PropTypes.shape({ min: PropTypes.number, max: PropTypes.number }),
  destinations: PropTypes.array,
  selectedDestinations: PropTypes.array,
  selectedPrice: PropTypes.any,
  tripTypes: PropTypes.any,
  selectedTripTypes: PropTypes.any,
  totalCount: PropTypes.number,
  destinationsHeader: PropTypes.node,
  priceHeader: PropTypes.node,
  priceLabel: PropTypes.node,
  tripTypeHeader: PropTypes.node,
  resetFilterLabel: PropTypes.node,
  showFilteredLabel: PropTypes.node,
  onReset: PropTypes.func,
  onShowFiltered: PropTypes.func,
};
